import { useEffect, useState } from "react";
import { axiosInstance } from "../../services/api/api";
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  styled,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";

//svg
import { ReactComponent as IconReload } from "../../assets/svg/reload.svg";
import { ReactComponent as IconTooltip } from "../../assets/svg/help-circle.svg";
import { usePlannerContext } from "../../services/context/planner-context";
import { TooltipWithIconCustom } from "./tooltip-custom";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.background.default,
    fontSize: 12,
    /*   boxShadow: theme.shadows[1],
     fontSize: 11 */
  },
}));

export const CheckboxPlanner = ({
  label,
  value,
  setValue,
  name = "",
  area,
  tooltip,
  disabled
}) => {
  const { validateStart, setValidateEnd, setErrors } = usePlannerContext();
  
  const currentValue =
    value === null || value === undefined || value === -1 ? false : value;

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const updateBuilding = async (buildingId, buildingInputs) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.put(
        `/buildings/updateBuilding/${buildingId}`,
        buildingInputs
      );

    } catch (error) {
      // Handle error
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const onChangeHandler = (e) => {
    const inputValue = e.target.checked;

    if (area && area.buildingId) {
      setValue(inputValue, name);
      const buildingInputs = {
        ...area.building,
        [name]: inputValue,
      };

      updateBuilding(area.buildingId, buildingInputs);
      
    }
  };

  const reloadHandler = () => {
    if (area && area.buildingId) {
      const buildingInputs = {
        ...area.building,
        [name]: currentValue,
      };

      updateBuilding(area.buildingId, buildingInputs);
    
    }
  };

  useEffect(()=>{
    if(validateStart > 0){
      if(error){
        setErrors(prev => prev + 1);
      } 
      setValidateEnd(prev => prev + 1);
    }
  }, [validateStart])

  return (
    <FormControl error={error} /* variant="standard" */ sx={{ width: "100%" }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <Checkbox
        disabled={disabled}
          disableRipple
          checked={currentValue}
          onChange={onChangeHandler}
          name={name}
          inputProps={{ "aria-label": "controlled" }}
          color="secondary"
          sx={{
            "&.MuiCheckbox-root": {
              color: "#dbdbeb",
              "&.Mui-checked": { color: "#343745" },
              padding: 0,
            },
          }}
        />
        <TooltipWithIconCustom text={tooltip} >
          <Typography
          sx={{
            fontSize: "12px",
            color: "#343745",
            fontWeight: 500,
          }}
        >
          {label}
        </Typography>
        </TooltipWithIconCustom>
        
        {loading && <CircularProgress size={15} />}
        {error && (
          <IconButton sx={{ padding: "4px" }} onClick={reloadHandler}>
            <IconReload stroke="#ba1a1a" width={"14px"} height={"14px"} />
          </IconButton>
        )}
      </Box>

      {error && (
        <FormHelperText
          sx={{ ml: 0, mr: 0 }}
          id="component-error-text"
        >
          Failed to save the value. Please click the reload button (
          {<IconReload stroke="#ba1a1a" width={"10px"} height={"10px"} />})
        </FormHelperText>
      )}
    </FormControl>
  );
};
